/* eslint-disable no-nested-ternary */
import { ChevronRight } from '../../assets/icons/chevron right'
import { Desconectar } from '../../components/Desconectar'
import { DivTitle } from '../../components/TitlePage/TitlePage'
import {
  Button,
  Container,
  ContainerInput,
  DivData,
  DivInput,
  Input,
  Span,
  Wrapper,
} from './EditUser.style'
import { useEditUser } from './useEditUser'

export function EditUser() {
  const {
    showData,
    handleChangeSetData,
    showPassword,
    handleChangeSetPassword,
    handleClickSetInput,
    showInputNameEmail,
    senha,
    setSenha,
    novaSenha,
    setNovaSenha,
    repetirSenha,
    setRepetirSenha,
    campoObrigatorioSenhaAtual,
    campoObrigatorioNovaSenha,
    campoObrigatorioConfirmarSenha,
    senhaNaoConfere,
    handleValidaSenha,
    setAlteraEmail,
    setAlteraNome,
    handleAlteraNomeEmail,
    campoObrigatorioEmail,
    campoObrigatorioNome,
    userData,
    alteraNome,
    alteraEmail,
    handleClear,
    handleEdit,
    showWhatsApp,
    handleChangeSetWhatsApp,
    tenantWhatsAppAtivo,
    whatsappInstancia,
    fetchAtivarWhatsApp,
    handleDeletaWhatsApp,
    desconectarWhatsApp,
    fechaDesconectarWhatsApp,
    desconectarWhatsAppInstancia,
  } = useEditUser()

  return (
    <>
      <DivTitle color="black" size={24}>
        Edição de Perfil
      </DivTitle>
      <Container>
        <div>
          <div>
            <Button
              buttonType={showData ? 'DATA' : 'PSWD'}
              type="button"
              onClick={handleChangeSetData}
            >
              Dados <ChevronRight white={!!showData} />
            </Button>
          </div>
          <div>
            <Button
              buttonType={showPassword ? 'DATA' : 'PSWD'}
              type="button"
              onClick={handleChangeSetPassword}
            >
              Alterar senha <ChevronRight white={!!showPassword} />
            </Button>
          </div>
          {tenantWhatsAppAtivo && (
            <div>
              <Button
                buttonType={showWhatsApp ? 'DATA' : 'PSWD'}
                type="button"
                onClick={handleChangeSetWhatsApp}
              >
                WhatsApp pessoal <ChevronRight white={!!showWhatsApp} />
              </Button>
            </div>
          )}
        </div>

        {showData && (
          <DivData>
            <h3>Dados</h3>
            <Wrapper>
              <Span>
                <b>Nome</b>{' '}
                {showInputNameEmail ? (
                  <ContainerInput>
                    <Input
                      type="text"
                      value={alteraNome}
                      placeholder={userData?.nome}
                      onChange={event => setAlteraNome(event.target.value)}
                    />
                  </ContainerInput>
                ) : (
                  <ContainerInput>
                    <em>{userData?.nome}</em>
                  </ContainerInput>
                )}
                {/* <ButtonEdit onClick={handleClickSetInput} type="button">
                  <EditIcon />
                </ButtonEdit> */}
              </Span>
              <DivInput>
                {campoObrigatorioNome ? (
                  <span>*O campo nome é obrigatório</span>
                ) : (
                  ''
                )}
              </DivInput>
              <Span>
                <b>E-mail</b>{' '}
                {showInputNameEmail ? (
                  <ContainerInput>
                    <Input
                      type="text"
                      value={alteraEmail}
                      placeholder={userData?.email}
                      onChange={event => setAlteraEmail(event.target.value)}
                    />
                  </ContainerInput>
                ) : (
                  <ContainerInput>
                    <em>{userData?.email}</em>
                  </ContainerInput>
                )}
                {/* <ButtonEdit onClick={handleClickSetInput} type="button">
                  <EditIcon />
                </ButtonEdit> */}
              </Span>
              <DivInput>
                {campoObrigatorioEmail ? (
                  <span>*O campo e-mail é obrigatório</span>
                ) : (
                  ''
                )}
              </DivInput>

              {showInputNameEmail ? (
                <Button
                  marginTop="15px"
                  buttonType="DATA"
                  type="button"
                  onClick={() => {
                    handleAlteraNomeEmail()
                    handleClear()
                  }}
                >
                  Salvar
                </Button>
              ) : (
                <Button
                  marginTop="15px"
                  buttonType="DATA"
                  type="button"
                  onClick={() => {
                    handleClickSetInput()
                    handleEdit()
                  }}
                >
                  Editar
                </Button>
              )}
            </Wrapper>
          </DivData>
        )}
        {showPassword && (
          <div>
            <h3>Alterar senha</h3>
            <Wrapper>
              <DivInput>
                <span className="title"> Senha atual </span>
                <div>
                  <Input
                    value={senha}
                    onChange={event => setSenha(event.target.value)}
                    type="password"
                    placeholder="Senha Atual"
                  />
                  {campoObrigatorioSenhaAtual ? (
                    <span>*Campo obrigatório</span>
                  ) : (
                    ''
                  )}
                </div>
              </DivInput>

              <DivInput>
                <span className="title"> Nova senha </span>
                <div>
                  <Input
                    value={novaSenha}
                    onChange={event => setNovaSenha(event.target.value)}
                    type="password"
                    placeholder="Nova Senha"
                  />
                  {campoObrigatorioNovaSenha ? (
                    <span>*Campo obrigatório</span>
                  ) : (
                    ''
                  )}
                </div>
              </DivInput>
              <DivInput>
                <span className="title"> Repetir senha </span>
                <div>
                  <Input
                    value={repetirSenha}
                    onChange={event => setRepetirSenha(event.target.value)}
                    type="password"
                    placeholder="Repetir Senha"
                  />
                  {campoObrigatorioConfirmarSenha ? (
                    <span>*Campo obrigatório</span>
                  ) : (
                    ''
                  )}
                  {senhaNaoConfere ? (
                    <span>*As senhas não coincidem. Tente novamente.</span>
                  ) : (
                    ''
                  )}
                </div>
              </DivInput>
              <Button
                marginTop="15px"
                buttonType="DATA"
                type="button"
                onClick={handleValidaSenha}
              >
                Salvar
              </Button>
            </Wrapper>
          </div>
        )}
        {showWhatsApp && (
          <DivData>
            <h3>WhatsApp pessoal</h3>
            <Wrapper>
              <Span>
                <b>Instância</b>{' '}
                <ContainerInput>
                  <em>{whatsappInstancia.ativo ? 'Ativa' : 'Inativa'}</em>
                </ContainerInput>
              </Span>
              {whatsappInstancia.ativo && (
                <Span>
                  <b>Status</b>{' '}
                  {whatsappInstancia.conectado ? (
                    <ContainerInput>
                      <em>Conectado</em> <em>{whatsappInstancia.numero}</em>
                    </ContainerInput>
                  ) : (
                    <ContainerInput>
                      {whatsappInstancia.qrcode ? (
                        <img
                          src={whatsappInstancia.qrcode}
                          alt="QR Code do WhatsApp"
                        />
                      ) : null}
                      <em>Desconectado</em>
                    </ContainerInput>
                  )}
                </Span>
              )}
              {whatsappInstancia.ativo ? (
                <Button
                  marginTop="15px"
                  buttonType="DATA"
                  type="button"
                  onClick={handleDeletaWhatsApp}
                >
                  Desconectar
                </Button>
              ) : (
                <Button
                  marginTop="15px"
                  buttonType="DATA"
                  type="button"
                  onClick={fetchAtivarWhatsApp}
                >
                  Ativar WhatsApp
                </Button>
              )}
            </Wrapper>
          </DivData>
        )}
        {desconectarWhatsApp && (
          <Desconectar
            texto="Deseja realmente desconectar seu WhatsApp pessoal?"
            botaoNao={fechaDesconectarWhatsApp}
            botaoSim={desconectarWhatsAppInstancia}
          />
        )}
      </Container>
    </>
  )
}
